import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from 'react-apollo';

import { getAsset } from '../../../../util/assets';
import ConsumerRootContentSearch from './ConsumerRootContentSearch';
import { HierarchyItemForPasswordValidation } from '../../../../apps/web-gallery/graphql/queries/hierarchy-item';

const propTypes = {
  values: PropTypes.shape({
    hierarchy_item_id: PropTypes.string,
  }),
  handleChange: PropTypes.func,
};

const OwnerEmailForm = ({ values, handleChange }) => {
  const { data: { hierarchyItem } = {} } = useQuery(
    HierarchyItemForPasswordValidation,
    {
      variables: {
        id: values.hierarchy_item_id,
      },
      skip: !values.hierarchy_item_id,
    },
  );

  const creatorEmail =
    hierarchyItem?.album?.creator?.pro_settings?.photo_attribution_page
      ?.email_address ??
    hierarchyItem?.album_folder?.account?.pro_settings?.photo_attribution_page
      ?.email_address ??
    hierarchyItem?.album?.creator?.email_address ??
    hierarchyItem?.album_folder?.account?.email_address;

  return (
    <Fragment>
      <div className="w-100 d-flex align-items-start">
        <img
          src={getAsset('/waldo-icon-error.svg')}
          width="40px"
          alt="Waldo Worried"
        />
        <p className="gray-box text-sm">
          <span className="text-bold text-dark">
            We&apos;re sorry you are experiencing issues
          </span>
          <br />
          For issues with the timing of photo uploads, coverage, and quality,
          you will need to contact the photographer for your event.
          <br />
          <br />
          Please select your event below and we can provide you their email.
        </p>
      </div>
      <ConsumerRootContentSearch values={values} handleChange={handleChange} />
      {hierarchyItem && creatorEmail && (
        <div className="w-100 d-flex align-items-start">
          <img src={getAsset('/waldo-icon.svg')} width="40px" alt="Waldo" />
          <p className="gray-box text-sm">
            <span className="text-bold text-dark">
              The email for the photographer at your event is &ndash;
            </span>
            <br />
            <a href={`mailto:${creatorEmail}`} className="text-extra-bold">
              {creatorEmail}
            </a>
          </p>
        </div>
      )}
      {hierarchyItem && !creatorEmail && (
        <div className="w-100 d-flex align-items-start">
          <img
            src={getAsset('/waldo-icon-error.svg')}
            width="40px"
            alt="Waldo Worried"
          />
          <p className="gray-box text-sm">
            <span className="text-bold text-dark">
              No email has been provided for this event
            </span>
          </p>
        </div>
      )}
    </Fragment>
  );
};

OwnerEmailForm.propTypes = propTypes;

export default OwnerEmailForm;
